/**
 * Build-time configuration, read once.
 *
 * The Entra identifiers are compiled into the bundle: they identify this application
 * to the directory, and the backend checks the client id as the token audience, so
 * changing them is a rebuild. `scripts/dev.sh` passes them from backend/.env, so
 * there is one copy.
 *
 * The upstream design system's MicrosoftSignInButton imports this module by name,
 * which is why it exists in this shape.
 */
export const ENTRA_TENANT_ID = import.meta.env.VITE_ENTRA_TENANT_ID ?? '';
export const ENTRA_CLIENT_ID = import.meta.env.VITE_ENTRA_CLIENT_ID ?? '';

/**
 * Always false here. Upstream, a mock directory can stand in for Entra in the
 * browser; in App Starter builds the development path is the backend's email sign-in,
 * offered by the sign-in page when `/api/auth/methods` says so. A second mock in the
 * browser would be a second way to believe somebody.
 */
export const IS_ENTRA_MOCK = false;

/** Both identifiers or neither: half a configuration should present as none. */
export const IS_ENTRA_SIGN_IN_ENABLED = ENTRA_TENANT_ID !== '' && ENTRA_CLIENT_ID !== '';
